import api from './api.js'

export const sendNotification = (data) => api.post('/admin/v1/notifications/send', data)
